import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './adm_dashboard_ux.css';
import PropTypes from 'prop-types';

// # Carousel component for dashboard sections
const AdminDashboardUX = ({ sections, isDarkMode }) => {
  const navigate = useNavigate();

  // # Get slider settings based on number of items
  const getSliderSettings = (itemCount) => {
    const baseSettings = {
      dots: true,
      infinite: itemCount > 2,
      speed: 500,
      autoplay: itemCount > 2,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      centerMode: false,
      centerPadding: '0',
      lazyLoad: 'ondemand',
      swipeToSlide: true,
      touchThreshold: 8,
      useCSS: true,
      useTransform: true,
      rows: 1,
      slidesPerRow: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: Math.min(2, itemCount),
            slidesToScroll: 1,
            infinite: itemCount > 2,
            dots: true,
            centerMode: false,
            adaptiveHeight: true,
            arrows: itemCount > 1,
            speed: 400
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: itemCount > 1,
            dots: true,
            centerMode: false,
            adaptiveHeight: true,
            swipeToSlide: true,
            touchThreshold: 5,
            arrows: itemCount > 1,
            speed: 350,
            variableWidth: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: itemCount > 1,
            dots: true,
            centerMode: false,
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 5,
            speed: 300,
            adaptiveHeight: true,
            variableWidth: false
          }
        }
      ]
    };

    if (itemCount >= 5) {
      return {
        ...baseSettings,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: false
      };
    } else if (itemCount >= 3) {
      return {
        ...baseSettings,
        slidesToShow: Math.min(3, itemCount),
        slidesToScroll: 1,
        variableWidth: false
      };
    } else {
      return {
        ...baseSettings,
        slidesToShow: itemCount,
        slidesToScroll: 1,
        arrows: itemCount > 1,
        draggable: itemCount > 1,
        variableWidth: false
      };
    }
  };

  // # Handle item click
  const handleItemClick = (item) => {
    // # If item has onClick handler, use it
    if (item.onClick) {
      item.onClick();
    } else {
      // # Otherwise, navigate to the path
      navigate(item.path);
    }
  };

  return (
    <div className={`adm_ux-sections ${isDarkMode ? 'adm_ux-dark-mode' : ''}`}>
      {Object.entries(sections).map(([key, section]) => (
        <div key={key} className="adm_ux-section adm_ux-animate-slide">
          <h3 className="adm_ux-section-title">{section.title}</h3>
          <div className={`adm_ux-carousel-container ${section.items.length <= 2 ? 'fixed-carousel' : ''}`}>
            <Slider {...getSliderSettings(section.items.length)}>
              {section.items.map((item, index) => (
                <div 
                  key={`${key}-${index}`}
                  className="adm_ux-carousel-item-wrapper"
                >
                  <div 
                    className="adm_ux-carousel-item adm_ux-animate-fade"
                    onClick={() => handleItemClick(item)}
                  >
                    <div className="adm_ux-item-content">
                      <div className="adm_ux-item-icon">
                        <img src={item.icon} alt={item.title} />
                      </div>
                      <h4 className="adm_ux-item-title">{item.title}</h4>
                      <p className="adm_ux-item-description">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ))}
    </div>
  );
};

AdminDashboardUX.propTypes = {
  sections: PropTypes.object.isRequired,
  isDarkMode: PropTypes.bool
};

export default AdminDashboardUX;
